import React, { useEffect } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { ScreenReaderContent } from '@companycam/slab-web';
import styled from 'styled-components';

const Label = styled.span`
  font-weight: 600;
  font-family: 'Averta', sans-serif;
  font-size: calc(var(--cc_size_text_s) + 1px);
`;

const Select = ({
  value,
  error,
  label,
  name,
  onChange,
  onBlur,
  valueAttribute,
  children,
  hideLabel,
}) => {
  useEffect(() => {
    if (value === undefined) {
      onChange(name, value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleBlur = () => {
    if (onBlur) {
      onBlur(name, true);
    }
  };

  const handleChange = (onChangeValue) => {
    if (!onChangeValue || !valueAttribute) {
      onChange(name, onChangeValue);
    } else if (valueAttribute) {
      onChange(
        name,
        Array.isArray(onChangeValue)
          ? onChangeValue.map((v) => v[valueAttribute])
          : onChangeValue[valueAttribute],
      );
    }
  };

  const classNames = cx('form-field', { error });
  return (
    <div className={classNames}>
      <label htmlFor={name}>
        {hideLabel ? (
          <ScreenReaderContent>{label}</ScreenReaderContent>
        ) : (
          <label htmlFor={label}>
            <Label>{label}</Label>
          </label>
        )}
      </label>
      {React.cloneElement(children, {
        value,
        onChange: handleChange,
        onBlur: handleBlur,
        name,
      })}
      {error ? <span className="validation-error">{error}</span> : null}
    </div>
  );
};

Select.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  error: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  valueAttribute: PropTypes.string,
  children: PropTypes.node,
  hideLabel: PropTypes.bool,
};

export default Select;
